import { render, staticRenderFns } from "./BrandShowScreen.vue?vue&type=template&id=74630f6e&"
import script from "./BrandShowScreen.vue?vue&type=script&lang=js&"
export * from "./BrandShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports